/* 
============================================= 
======           Modules          =========== 
============================================= 
*/
import { BrowserModule }        from '@angular/platform-browser';
import { NgModule }             from '@angular/core';
import { FormsModule }          from '@angular/forms';
import { HttpModule }           from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

/* 
============================================= 
=======          Components         ========= 
============================================= 
*/
import { AppComponent } from './app.component';

// Defaults
import { NotFoundComponent }             from './components/defaults/not-found/not-found.component';
import { NotAllowedComponent }           from './components/defaults/not-allowed/not-allowed.component';
import { MenuComponent }                 from './components/defaults/menu/menu.component';
import { HomeComponent }                 from './components/defaults/home/home.component';
import { FooterComponent }               from './components/defaults/footer/footer.component';
import { LoginComponent }                from './components/defaults/login/login.component';
import { AlertsComponent }               from './components/defaults/alerts/alerts.component';
import { ConfirmRegistrationComponent }  from './components/defaults/confirm-registration/confirm-registration.component';
import { PreloaderComponent }            from './components/defaults/preloader/preloader.component';
import { DashboardAdminComponent }       from './components/defaults/dashboard-admin/dashboard-admin.component';
import { ColorBinder }                   from './components/defaults/color-binder/color-binder';
import { YourDreamSelect }               from './components/defaults/yd-select/yd-select.component';
import { NotesHistory }                  from './components/defaults/notes-history/notes-history';

// Clients
import { AddClientComponent }            from './components/clients/add-client/add-client.component';
import { EditClientComponent }           from './components/clients/edit-client/edit-client.component';
import { ClientComponent }               from './components/clients/client/client.component';
import { ClientsComponent }              from './components/clients/clients/clients.component';

// Projects
import { AddOrEditProject }              from './components/projects/add-or-edit/add-or-edit-project';
import { ProjectComponent }              from './components/projects/project/project.component';
import { ProjectsComponent }             from './components/projects/projects/projects.component';

// Products
import { ProductComponent }              from './components/products/product/product.component';
import { ProductsComponent }             from './components/products/products/products.component';
import { ProductsClonePopupComponent }   from './components/products/products/products-clone-popup.component';
import { AddProductComponent }           from './components/products/add-product/add-product.component';
import { EditProductComponent }          from './components/products/edit-product/edit-product.component'
import { ProductsSpecsComponent }        from './components/products/specs/products-specs'

// Manufacturers
import { AddManufacturerComponent }      from './components/manufacturers/add-manufacturer/add-manufacturer.component';
import { EditManufacturerComponent }     from './components/manufacturers/edit-manufacturer/edit-manufacturer.component';
import { ManufacturerComponent }         from './components/manufacturers/manufacturer/manufacturer.component';
import { ManufacturersComponent }        from './components/manufacturers/manufacturers/manufacturers.component';

// Users
import { AddUserComponent }              from './components/users/add-user/add-user.component';
import { EditUserComponent }             from './components/users/edit-user/edit-user.component';
import { UserComponent }                 from './components/users/user/user.component';
import { UsersComponent }                from './components/users/users/users.component';

// Rebates
import { AddRebateComponent }            from './components/rebates/add-rebate/add-rebate.component';
import { EditRebateComponent }           from './components/rebates/edit-rebate/edit-rebate.component';
import { RebatesComponent }              from './components/rebates/rebates/rebates.component';
import { RebateComponent }               from './components/rebates/rebate/rebate.component';

// Suppliers
import { AddSupplierComponent }          from './components/suppliers/add-supplier/add-supplier.component';
import { EditSupplierComponent }         from './components/suppliers/edit-supplier/edit-supplier.component';
import { SupplierComponent }             from './components/suppliers/supplier/supplier.component';
import { SuppliersComponent }            from './components/suppliers/suppliers/suppliers.component';

import { Ng4InputMaskModule }            from './services/input-mask/ng4-input-mask.module';
import { NKDatetimeModule }              from 'ng2-datetime/ng2-datetime';


import { DashboardExportCsvComponent }   from './components/defaults/dashboard-admin/dashboard-export-csv/dashboard-export-csv.component';
import { TaxSelectComponent }            from './components/projects/tax-select/tax-select.component';
import { SearchSKUComponent }            from './components/defaults/search-sku/search-sku.component';
import { DashboardReferrerComponent }    from './components/defaults/dashboard-referrer/dashboard-referrer.component';
import { ProposalTabComponent }          from './components/projects/project/proposal-tab/proposal-tab.component';
import { BreakdownTabComponent }         from './components/projects/project/breakdown-tab/breakdown-tab.component';

/* 
============================================= 
=======           Services          ========= 
============================================= 
*/
import { ImagesService } from './services/images.service';
import { GlobalService } from './services/global.service';
import { LoginService }  from './services/login.service';
import { ModelService }  from './services/model.service';
import { AlertsService } from './services/alerts.service';
import { WindowRef }     from '../classes/windowRef';




/* 
============================================= 
=======           Routes          =========== 
============================================= 
*/
const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  
  { path: 'add/user', component: AddUserComponent },
  { path: 'edit/user/:id', component: EditUserComponent },
  { path: 'user-detail/:id', component: UserComponent },
  { path: 'users-list', component: UsersComponent },

  { path: 'add/client', component: AddClientComponent },
  { path: 'edit/client/:id', component: EditClientComponent },
  { path: 'client-detail/:id', component: ClientComponent },
  { path: 'clients-list', component: ClientsComponent },

  { path: 'add/manufacturer', component: AddManufacturerComponent },
  { path: 'edit/manufacturer/:id', component: EditManufacturerComponent },
  { path: 'manufacturer-detail/:id', component: ManufacturerComponent },
  { path: 'manufacturers-list', component: ManufacturersComponent },

  { path: 'project/add', component: AddOrEditProject },
  { path: 'project/edit/:id', component: AddOrEditProject },
  //{ path: 'project/editt/:id', component: ProjectSettingsComponent },
  // ToDo make restful
  { path: 'project-detail/:id', component: ProjectComponent },
  { path: 'projects-list', component: ProjectsComponent },
  
  { path: 'add/product', component: AddProductComponent },
  { path: 'edit/product/:id', component: EditProductComponent },
  { path: 'product-detail/:id', component: ProductComponent },
  { path: 'products-list', component: ProductsComponent },
  { path: 'products-specs', component: ProductsSpecsComponent },
  
  { path: 'add/rebate', component: AddRebateComponent },
  { path: 'edit/rebate/:id', component: EditRebateComponent },
  { path: 'rebate-detail/:id', component: RebateComponent },
  { path: 'rebates-list', component: RebatesComponent },

  { path: 'add/supplier', component: AddSupplierComponent },
  { path: 'edit/supplier/:id', component: EditSupplierComponent },
  { path: 'supplier-detail/:id', component: SupplierComponent },
  { path: 'suppliers-list', component: SuppliersComponent },
  
  { path: 'confirm-registration', component: ConfirmRegistrationComponent },
  { path: 'not-allowed', component: NotAllowedComponent },
  { path: '**', component: NotFoundComponent }
];






@NgModule({
  declarations: [
    AppComponent,
    AddClientComponent,
    AddOrEditProject,
    NotFoundComponent,
    MenuComponent,
    HomeComponent,
    FooterComponent,
    LoginComponent,
    ClientsComponent,
    ProjectsComponent,
    ProjectComponent,
    ClientComponent,
    AlertsComponent,
    EditClientComponent,
    UsersComponent,
    UserComponent,
    AddUserComponent,
    EditUserComponent,
    ConfirmRegistrationComponent,
    NotAllowedComponent,
    PreloaderComponent,
    ColorBinder,
    YourDreamSelect,
    NotesHistory,
    ProductComponent,
    ProductsComponent,
    ProductsClonePopupComponent,
    AddProductComponent,
    EditProductComponent,
    ProductsSpecsComponent,
    AddManufacturerComponent,
    EditManufacturerComponent,
    ManufacturerComponent,
    ManufacturersComponent,
    DashboardAdminComponent,
    AddRebateComponent,
    EditRebateComponent,
    RebatesComponent,
    RebateComponent,
    AddSupplierComponent,
    EditSupplierComponent,
    SupplierComponent,
    SuppliersComponent,
    DashboardExportCsvComponent,
    TaxSelectComponent,
    SearchSKUComponent,
    DashboardReferrerComponent,
    ProposalTabComponent,
    BreakdownTabComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule,
    RouterModule.forRoot( appRoutes ),
    Ng4InputMaskModule,
    NKDatetimeModule
  ],
  providers: [
    ImagesService, 
    GlobalService, 
    LoginService, 
    ModelService, 
    AlertsService,
    WindowRef],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /root/anvel/angular/app/app.module.ts